/* eslint-disable no-undef */
import { hot } from 'react-hot-loader/root';
import React, { Component } from 'react';
import '@styles/pages/app.scss';
import Swiper from './../node_modules/swiper/js/swiper';
import './../node_modules/swiper/css/swiper.css'
import bg from './assets/images/bg.png';
import Pagination  from 'rc-pagination';
import './../node_modules/rc-pagination/assets/index.css';

import Recommend from './hooks/recommend';
import Item from './hooks/item';

const getURLParam = (name) => {
  const value = window.location.search.match(
    new RegExp('[?&]' + name + '=([^&]*)(&?)', 'i'),
  );
  return value ? decodeURIComponent(value[1]) : value;
}

class App extends Component {
  constructor(props) {
    super(props);
    this.pageChange = this.pageChange.bind(this);
    this.fetch = this.fetch.bind(this);
    this.state = {
      topdata: [],
      labels: [],
      label: 0,
      wholeData: [],
      showData: [],
      heads: [],
      index: 0,
      updatePage: true,
    };
  }

  componentDidMount() {
    const that = this;
    window.report({
      eid: 'pageview/livecoursevideo/',
      eid_desc: '浏览量/开播教程视频专题',
    });
    new Promise(resolve => {
      $.ajax({
        url: 'https://diy-assets.msstatic.com/anchorvideocourse/videocall.html',
        data: {},
        type: 'Get',
        dataType: 'jsonp',
        jsonpCallback: 'videocall',
        success(res) {
          let indexs = 0;
          if (res.topicids && getURLParam('id')) {
            res.topicids.forEach((item, index_) => {
              if (item.id === Number(getURLParam('id'))) {
                indexs = index_;
              }
            });
          }
          that.setState({
            index: indexs,
            labels: res.topicids,
            heads: res.headImg.length === 0 ? [
              {
                img: bg,
                url: '',
              },
            ] : res.headImg,
          }, () => {
            resolve(res);
            new Swiper('.swiper-containers', {
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
              simulateTouch: false,
              autoplay: {
                delay: 3000,
                stopOnLastSlide: false,
                disableOnInteraction: false,
              },
            })
          })
        },
      })
    })
      .then(val => {
        $.ajax({
          url: 'https://v.huya.com/index.php?r=jsapi/getVideoInfo',
          data: {
            vids: val.vids.toString(),
          },
          type: 'GET',
          dataType: 'jsonp',
          success(res) {
            const data = [];
            val.vids.forEach(item => {
              Object.keys(res).forEach(items => {
                if (item !== Number(items)) return;
                data.push(res[items])
              })
            })
            that.setState({
              topdata: data,
            })
          },
        });
        if (val.topicids.length === 0) return;
        $.ajax({
          url: `https://v-api-plus.huya.com/jsapi/topicvideos?callback=videoV2&page=1&pageSize=1000`,
          data: {
            topicId: val.topicids[that.state.index].id,
          },
          type: 'GET',
          dataType: 'jsonp',
          success(res) {
            that.setState({
              wholeData: res,
              showData: res.slice(0, 12),
            })
          },
        });
      })
  }

  pageChange(current, pageSize) {
    $('html, body').animate({scrollTop: $('#mao').offset().top - 60}, 0)
    this.setState(state => ({
      showData: state.wholeData.slice((current - 1) * pageSize, (current) * pageSize >= state.wholeData.length ? state.wholeData.length : (current) * pageSize),
    }))
  }

  fetch() {
    const that = this;
    $.ajax({
      url: `https://v-api-plus.huya.com/jsapi/topicvideos?callback=videoV2&topicId=${this.state.labels[this.state.index].id}&page=1&pageSize=1000`,
      data: {},
      type: 'GET',
      dataType: 'jsonp',
      success(res) {
        that.setState({
          wholeData: res,
          showData: res.slice(0, 12),
          updatePage: false,
        }, () => {
          that.setState({
            updatePage: true,
          })
        })
      },
    });
  }

  render() {
    const { heads, topdata, showData, wholeData, labels } = this.state;
    return (
      <div id="app">
        <section className = 'lunbo'>
          <div className = "swiper-containers">
            <div className = "swiper-wrapper">
              {
                heads.map(item => (
                  <div key = {Math.random()} className = "swiper-slide">
                    <img
                      src = {item.img}
                      alt = {item.url}
                      onError={event => {
                        event.target.onerror = null;
                        event.target.src = bg;
                      }}
                      onClick = {
                        () => {
                          if (item.url === '') return;
                          window.report({
                            eid: 'click/livecoursevideo/banner',
                            eid_desc: '点击/开播教程视频专题/头图bannner',
                          });
                          window.open(item.url, '_blank').location;
                        }
                      }
                    />
                  </div>
                ))
              }
            </div>
            <div className = "swiper-pagination"></div>
          </div>
        </section>
        <section className = 'recommend'>
          <h1>官方课程推荐</h1>
          <div className = 'listBox'>
            <Recommend data = {topdata}/>
          </div>
        </section>
        <section className = 'allrecommend' id='mao'>
          <div className = 'all_title'>
            <h1>全部课程</h1>
            {
              labels.map((item, index_) => (
                <div
                  key = {item.id}
                  className = {index_ === this.state.index ? 'labels' : 'label'}
                  onClick = {() => {
                    this.setState({
                      index: index_,
                    }, () => {
                      this.fetch(index_);
                    })
                  }}
                >{item.desc}</div>
              ))
            }
          </div>
          <div
            className = 'listBox'
          >
            {
              showData.map(item => (
                <div
                  key = {item.vid}
                  className = 'item-cover'
                  onClick = {() => {
                    window.report({
                      eid: 'click/livecoursevideo/classification',
                      eid_desc: '点击/开播教程视频专题/分类视频',
                    });
                  }}
                >
                  <Item {...item}/>
                </div>
              ))
            }
          </div>
        </section>
        <section className = 'page'>
          {
            this.state.updatePage && wholeData.length !== 0 &&
            <Pagination
              total = {wholeData.length}
              defaultCurrent = {1}
              pageSize = {12}
              onChange = {this.pageChange}
            />
          }
        </section>
      </div>
    );
  }
}

// 开启 webpack 的 HMR
export default hot(App);
